import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { EmptyState } from '@/components/EmptyState';

export function NotFoundPage() {
  return (
    <EmptyState
      icon={<Compass />}
      title="ページが見つかりません"
      description="URL が正しいかご確認ください。メニューから目的の画面を開き直してください。"
      action={<Link to="/">ポータルへ戻る</Link>}
    />
  );
}
